import { useQuery } from '@tanstack/react-query'

import { apiFetch } from './apiFetch'

export const useProperties = (projectId) =>
  useQuery({
    queryKey: ['properties', projectId],
    queryFn: () => apiFetch(`/api/user/projects/${projectId}/properties`),
    enabled: !!projectId,
    retry: false,
  })
